function GoverningStructure() {
  return (
    <>
<section className="governingStructure pb-0" id="governing-structure">
    <h1 className="section-title text-center pb-4">Governing Structure​​</h1>
    <p className="text-center mb-5 pb-5 d-none">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been<br className="d-none d-md-block" /> the industry's standard dummy text ever sinc</p>
    <div className="MinisterTransportWrap">
        <div className="MinisterTransport">
            <div className="title">MINISTER OF TRANSPORT</div>
            <div className="MinisterTransportBody">
                <ul>
                    <li>
                        <div className="row justify-content-center">
                            <div className="col-sm-auto">
                                <div class="star-block">
                                    <div class="icon">
                                        <i></i>
                                    </div>
                                    <p><b>BOARD</b> OF DIRECTORS</p>
                                </div>
                            </div>
                            <div className="col-sm-auto">
                                <div className="star-div"></div>
                            </div>
                            <div className="col-sm-auto">
                                <div>
                                    <ul className="tick">
                                        <li>Maritime Industry Committee</li>
                                        <li>Remuneration Committee</li>
                                        <li>
                                            AUDIT & risk committee
                                            {/* <ul className="star-li">
                                                <li>Finance & IT Committee</li>
                                                <li>Risk Management Committee</li>
                                            </ul> */}
                                        </li>
                                        <li>Finance & IT Committee</li>
                                        <li>Risk Management Committee</li>
                                        
                                    </ul>


                                </div>
                            </div>
                        </div>
                    </li>
                    <div className="row align-items-center">
                        <div className="col-auto">
                            <div className="dark-star">
                                <i></i>
                            </div>
                        </div>
                        
                        <div className="col font-20 lineHeight-26">
                            {/* <span className="font-600 d-block">COMPANY</span> SECRETARY
                             */}
                              <p style={{ fontSize: '1rem' }}>
                                <b>COMPANY</b><br /> SECRETARY</p>

                        </div>
                    </div>
                    <li>
                        <div className="row justify-content-center">
                            <div className="col-sm-auto">
                                <div class="star-block">
                                    <div class="icon">
                                        <i></i>
                                    </div>
                                    <p><b>CHIEF </b> EXECUTIVE OFFICER</p>
                                </div>
                            </div>
                            <div className="col-sm-auto">
                                <div className="star-div"></div>
                            </div>
                            <div className="col-sm-auto">
                                <div>
                                    <ul className="tick">
                                        <li>
                                            Executive Committee (EXCO)
                                            <ul className="star-li">
                                                <li>OPERATIONS</li>
                                                <li>FINANCE</li>
                                                <li>HUMAN CAPITAL</li>
                                                <li>Corporate Affairs and International Relations</li>
                                                <li>Policy and Regulatory Affairs</li>
                                                <li>INFORMATION TECHNOLOGY</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>
    </>
  )
}

export default GoverningStructure